import { makeStyles } from '@mui/styles';

export const dropdownSelectStyles = makeStyles(() => ({
    dropdownMenu: {
        marginTop: '4px',
        borderRadius: '6px',

        '& .MuiPaper-elevation8': {
            border: '1px solid var(--color-gray-300)',
            borderRadius: '6px',
            boxShadow: '0px 4px 6px -2px #10182808, 0px 12px 16px -4px #10182814',
        },
    },

    menuHeading: {
        '&.MuiMenuItem-root': {
            padding: '4px 12px 14px 12px',
            cursor: 'default',
            borderBottom: '1px solid var(--color-gray-300)',
            opacity: '1 !important',

            '&:hover': {
                background: '#fff',
            },
        },
    },

    menuHeadingText: {
        '&.MuiTypography-root': {
            fontFamily: 'var(--font-rubik)',
            fontSize: 'var(--font-size-xs)',
            lineHeight: '16px',
            color: 'var(--color-gray-700)',
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
        },
    },

    menuItem: {
        '&.MuiMenuItem-root': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            gap: '10px',
            fontFamily: 'var(--font-rubik)',
            fontSize: 'var(--font-size-sm)',
            fontWeight: '400',
            lineHeight: '20px',
            padding: '10px 16px',
            background: '#fff',
            color: 'var(--color-gray-800)',

            '&:hover': {
                background: '#F5F5F5',
            },
        },
    },

    menuItemActive: {
        '&.MuiMenuItem-root': {
            background: '#EFF8FF',

            '&:hover': {
                background: '#DBEAFE',
            },
        },
    },
}));
